import dateFormat from "dateformat";
import * as FileSaver from "file-saver";
import XLSX from "tempa-xlsx";
import { strToArrBuffer, excelSheetFromDataSet } from "../../utilities/dataHelpers";
import pdfImage from "../../components/PDF/pdfImage";

export const RPT210Excel = (dataReport, setShowMessages, setLoading) => {
    let filename = "RPT210_" + dateFormat(new Date(), "yyyymmdd");
    const setBorder = {
        left: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        right: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        top: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        bottom: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
    };

    const styles = {
        styleTextHeaders: {
            fill: {
                fgColor: { rgb: "c7c7c7" },
            },
            font: { bold: true },
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
            },
            border: setBorder,
        },
        styleHeaders: {
            fill: {
                fgColor: { rgb: "c7c7c7" },
            },
            font: { bold: true },
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
            },
            border: setBorder,
        },
        styleBorderB: {
            fill: {
                fgColor: { rgb: "ffffff" },
            },
            border: setBorder,
            alignment: {
                vertical: "center",
                wrapText: true,
            },
        },
        styleBorderTextCenter: {
            fill: {
                fgColor: { rgb: "ffffff" },
            },
            border: setBorder,
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
            },
        },
        styleSummaryHeaders: {
            fill: {
                fgColor: { rgb: "ffd966" },
            },
            font: { bold: true },
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
            },
            border: setBorder,
        },
        styleSummary: {
            fill: {
                fgColor: { rgb: "ffd966" },
            },
            font: { bold: true },
            alignment: {
                horizontal: "right",
                vertical: "center",
                wrapText: true,
            },
            border: setBorder,
        },
    };
    const chk = (key) => {
        if (dataReport.length > 0) {
            return dataReport[0][key] === "Y" ? "X" : "";
        }
    };

    if (dataReport.length > 0) {
        let dataExcel = [];

        let mergesData = [
            { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } },
            { s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
            { s: { r: 3, c: 1 }, e: { r: 3, c: 2 } },
            { s: { r: 4, c: 1 }, e: { r: 4, c: 2 } },
            { s: { r: 5, c: 1 }, e: { r: 5, c: 2 } },

            { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } },
            { s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
            { s: { r: 3, c: 5 }, e: { r: 3, c: 6 } },
            { s: { r: 4, c: 5 }, e: { r: 4, c: 6 } },
            { s: { r: 5, c: 5 }, e: { r: 5, c: 6 } },

            { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } },
            { s: { r: 2, c: 9 }, e: { r: 2, c: 10 } },
            { s: { r: 3, c: 9 }, e: { r: 3, c: 10 } },
            { s: { r: 4, c: 9 }, e: { r: 4, c: 10 } },
            { s: { r: 5, c: 9 }, e: { r: 5, c: 10 } },

            { s: { r: 1, c: 13 }, e: { r: 1, c: 14 } },
            { s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
            { s: { r: 3, c: 13 }, e: { r: 3, c: 14 } },
            { s: { r: 4, c: 13 }, e: { r: 4, c: 14 } },
            { s: { r: 5, c: 13 }, e: { r: 5, c: 14 } },

            // Header Table
            // row 1
            { s: { r: 7, c: 0 }, e: { r: 9, c: 0 } },
            { s: { r: 7, c: 1 }, e: { r: 9, c: 1 } },
            { s: { r: 7, c: 2 }, e: { r: 9, c: 2 } },
            { s: { r: 7, c: 3 }, e: { r: 9, c: 3 } },
            { s: { r: 7, c: 4 }, e: { r: 9, c: 4 } },
            { s: { r: 7, c: 6 }, e: { r: 7, c: 7 } },
            { s: { r: 7, c: 8 }, e: { r: 9, c: 8 } },
            { s: { r: 7, c: 9 }, e: { r: 9, c: 9 } },
            { s: { r: 7, c: 10 }, e: { r: 7, c: 13 } },
            { s: { r: 7, c: 14 }, e: { r: 9, c: 14 } },
            // row 2
            { s: { r: 8, c: 5 }, e: { r: 9, c: 5 } },
            { s: { r: 8, c: 6 }, e: { r: 8, c: 7 } },
            { s: { r: 8, c: 10 }, e: { r: 8, c: 11 } },
            { s: { r: 8, c: 12 }, e: { r: 8, c: 13 } },

            // Footer
        ];

        // Date
        const c1 = ["", "", "", "", "", "", "", "", "", "", "", "", "", " วันที่ " + dataReport[0].reportDate + " "];
        let a1 = [];
        for (const iterator of c1) {
            console.log(iterator);
            a1.push({ value: iterator, style: null });
        }
        dataExcel.push(a1);

        const c2 = [
            [
                { value: "", style: null },
                { value: "[ " + chk("weekFlag") + " ] รายสัปดาห์ [ " + chk("monthFlag") + " ] รายเดือน", style: null },
                { value: "ระหว่างวันที่ " + dataReport[0].reportDateBegin + " ", style: null },
                { value: "ถึงวันที่ " + dataReport[0].reportDateEnd, style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
            ],
            [
                { value: "เลขที่สัญญา", style: null },
                { value: " " + dataReport[0].contractNo + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "ผู้ควบคุมงาน", style: null },
                { value: " " + dataReport[0].supervisorName + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วันที่เริ่มสัญญา", style: null },
                { value: " " + dataReport[0].contractDateBegin + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วงเงินดำเนินการ", style: null },
                { value: " " + dataReport[0].operateAmount + " ", style: null },
            ],
            [
                { value: "PO", style: null },
                { value: " " + dataReport[0].planNo + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "ผู้รับจ้าง", style: null },
                { value: " " + dataReport[0].contractorName + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วันสิ้นสุดสัญญา", style: null },
                { value: " " + dataReport[0].contractDateEnd + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วงเงินคงเหลือ", style: null },
                { value: " " + dataReport[0].remainAmount + " ", style: null },
            ],
            [
                { value: "AUC(ค่าแรง)", style: null },
                { value: " " + dataReport[0].auc + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วงเงินสัญญา", style: null },
                { value: " " + dataReport[0].contractAmount + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "วันส่งงานเส้นทาง", style: null },
                { value: " " + dataReport[0].lastDeliverDate + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
            ],
            [
                { value: "วันที่ลงนาม ", style: null },
                { value: " " + dataReport[0].contractSignDate + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "อัตราค่าปรับ (บาท/วัน)", style: null },
                { value: " " + dataReport[0].fineRate + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "ระยะเวลาตามสัญญา", style: null },
                { value: " " + dataReport[0].contractPeriod + " ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "ระยะเวลาก่อสร้างจริง", style: null },
                { value: " " + dataReport[0].actualPeriod + " ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
            ],
        ];

        for (let i = 0; i < c2.length; i++) {
            dataExcel.push(c2[i]);
        }

        // ADD Headers
        dataExcel.push(
            [
                { value: "เส้นทาง", style: styles.styleHeaders },
                { value: "หน่วยงานเจ้าของพื้นที่", style: styles.styleHeaders },
                { value: "สถานที่", style: styles.styleHeaders },
                { value: "ผิว" + "\n" + "จราจร", style: styles.styleHeaders },
                { value: "เลขที่แบบเเปลน", style: styles.styleHeaders },
                { value: "ตามแบบ", style: styles.styleHeaders },
                { value: "ผลงานก่อสร้าง", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "วันที่อนุมัติเข้า", style: styles.styleHeaders },
                { value: "ระยะเวลา(วัน)", style: styles.styleHeaders },
                { value: "วันที่ทำการก่อสร้าง", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "ตรวจรับงานครั้งสุดท้ายวันที่", style: styles.styleHeaders },
            ],
            [
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "ความยาวท่อ(ม.)", style: styles.styleHeaders },
                { value: "ความยาวท่อ(ม.)", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "ตามแผน", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "ตามจริง", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
            ],
            [
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "สัปดาห์", style: styles.styleHeaders },
                { value: "รวม", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
                { value: "เริ่มงาน", style: styles.styleHeaders },
                { value: "สิ้นสุด", style: styles.styleHeaders },
                { value: "เริ่มงาน", style: styles.styleHeaders },
                { value: "แล้วเสร็จ", style: styles.styleHeaders },
                { value: "", style: styles.styleHeaders },
            ]
        );

        // Add row data
        let _row = 0;
        const chk_val = (val) => {
            return val === "" || val === null ? "" : val;
        };
        for (const iterator of dataReport) {
            _row++;
            dataExcel.push([
                { value: "" + chk_val(iterator.routeNo) + "", style: styles.styleBorderTextCenter },
                { value: "" + chk_val(iterator.areaOwner) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.areaLocation) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.areaSurface) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.planNo) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.asDesignPipeLength) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.resultLength) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.resultAccure) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.approveDate) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.duration) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.datePlanBegin) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.datePlanEnd) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.dateActualBegin) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.dateActualEnd) + "", style: styles.styleBorderB },
                { value: "" + chk_val(iterator.acceptDate) + "", style: styles.styleBorderB },
            ]);
            if (_row == dataReport.length) {
                mergesData.push({ s: { r: _row + 10, c: 0 }, e: { r: _row + 10, c: 4 } }, { s: { r: _row + 10, c: 8 }, e: { r: _row + 10, c: 14 } });
            }
        }
        // footer
        dataExcel.push([
            { value: "ผลรวม", style: styles.styleBorderTextCenter },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleBorderB },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
            { value: "", style: styles.styleHeaders },
        ]);

        // container bottom table
        mergesData.push({ s: { r: dataReport.length + 12, c: 1 }, e: { r: dataReport.length + 12, c: 5 } }, { s: { r: dataReport.length + 12, c: 7 }, e: { r: dataReport.length + 12, c: 9 } }, { s: { r: dataReport.length + 13, c: 1 }, e: { r: dataReport.length + 13, c: 5 } });

        const c3 = [
            [],
            [
                { value: "หมายเหตุ", style: null },
                { value: "1.ตรวจรับงานแล้ว .............. เส้นทาง ระหว่างดำเนินการ  .............. เส้นทาง ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "คณะกรรมการตรวจการจ้าง ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: " ประธานกรรมการ ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "2. เบิกเงินแล้ว .............. งวด เป็นเงิน .............. ", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "กรรมการ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "3. งานล่าช้า", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "", style: null },
                { value: "กรรมการ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "4. ขยายอายุสัญญา ................. ครั้ง", style: null },
            ],
            [
                { value: "", style: null },
                { value: "5. เพิ่มวงเงินสัญญาอีก ................. บาท", style: null },
            ],
            [
                { value: "", style: null },
                { value: "6. .................................. ", style: null },
            ],
            [],
            [],
            [{ value: "เรียน กรรมการและเลขานุการ เลขที่สัญญา  " + dataReport[0].contractNo + " ", style: null }],
            [
                { value: "", style: null },
                { value: "เพื่อโปรทราบ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "", style: null },
                { value: "( ............................. )", style: null },
            ],
            [
                { value: "", style: null },
                { value: "", style: null },
                { value: " ผู้ควบคุมงาน ", style: null },
            ],
            [
                { value: "", style: null },
                { value: "", style: null },
                { value: " ผู้จัดทำรายงาน ", style: null },
            ],
        ];

        for (let i = 0; i < c3.length; i++) {
            dataExcel.push(c3[i]);
        }

        const wb = {
            SheetNames: [filename],
            Sheets: {
                [filename]: excelSheetFromDataSet([
                    {
                        columns: null,
                        data: dataExcel,
                        merges: mergesData,
                        page: "RPT210",
                    },
                ]),
            },
        };

        const wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "binary",
        });
        let data = new Blob([strToArrBuffer(wbout)], {
            type: "application/octet-stream",
        });
        FileSaver.saveAs(data, filename + "." + "xlsx");
        setLoading(false);
    } else {
        setShowMessages("warn", `เกิดข้อผิดพลาด`, "ไม่พบข้อมูลส่งออก");
        setLoading(false);
    }
};
